<template>
  <div class="general-settings">
    <v-card class="settings-card" elevation="0">
      <!-- Main Content -->
      <div v-if="$store.state.loading" class="text-center pa-10">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
        <div class="mt-4">Loading settings...</div>
      </div>
      <div v-else class="settings-content">
        <!-- Coffee Processor Output Lot ID Method -->
        <div class="section mb-6">
          <h2 class="section-title mb-2">Coffee Processor Output Lot ID Method</h2>
          <h3 class="section-subtitle mb-6">
            Define how IDs are assigned to new lots created during the Quality Grading process.
          </h3>

          <!-- Green Beans Lot ID Type -->
          <div class="lot-id-section mb-8">
            <h4 class="lot-id-section-title mb-4">Select Lot ID Type for Green Beans</h4>
            <v-radio-group v-model="coffeeProcessorSettings.greenBeansLotIdType" class="lot-id-radio-group">
              <v-radio
                value="system"
                label="System Generated ID"
                class="lot-id-radio"
              >
                <template v-slot:label>
                  <span class="lot-id-label">System Generated ID</span>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        color="primary"
                        class="ml-2 info-icon"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-information
                      </v-icon>
                    </template>
                    <span>System will automatically generate the lot ID</span>
                  </v-tooltip>
                </template>
              </v-radio>
              <v-radio
                value="manual"
                label="Manual Lot ID (Outturn Number)"
                class="lot-id-radio"
              >
                <template v-slot:label>
                  <span class="lot-id-label">Manual Lot ID (Outturn Number)</span>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        color="primary"
                        class="ml-2 info-icon"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-information
                      </v-icon>
                    </template>
                    <span>User will manually enter the outturn number as the lot ID</span>
                  </v-tooltip>
                </template>
              </v-radio>
            </v-radio-group>
          </div>

          <!-- Quality Grading Lot ID Type -->
          <div class="lot-id-section">
            <h4 class="lot-id-section-title mb-4">Select Lot ID Type for Green Beans Quality Grades</h4>
            <v-radio-group v-model="coffeeProcessorSettings.qualityGradingLotIdType" class="lot-id-radio-group">
              <v-radio
                value="system"
                label="System Generated ID"
                class="lot-id-radio"
              >
                <template v-slot:label>
                  <span class="lot-id-label">System Generated ID</span>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        color="primary"
                        class="ml-2 info-icon"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-information
                      </v-icon>
                    </template>
                    <span>System will automatically generate the lot ID for quality grades</span>
                  </v-tooltip>
                </template>
              </v-radio>
              <v-radio
                value="manual"
                label="Manual Lot ID"
                class="lot-id-radio"
              >
                <template v-slot:label>
                  <span class="lot-id-label">Manual Lot ID</span>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        color="primary"
                        class="ml-2 info-icon"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-information
                      </v-icon>
                    </template>
                    <span>User will manually enter the lot ID for quality grades</span>
                  </v-tooltip>
                </template>
              </v-radio>
            </v-radio-group>
          </div>

                    <!-- Default Coffee Data settings -->
          <div class="lot-id-section mb-8">
            <h4 class="lot-id-section-title mb-4">Default Coffee Data Settings</h4>
               <v-radio-group v-model="coffeeProcessorSettings.defaultCoffeeDataSetting" class="lot-id-radio-group">
              <v-radio
                :value="false"
                label="Show Default Data"
                class="lot-id-radio"
              >
                <template v-slot:label>
                  <span class="lot-id-label">Show Default Data</span>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        color="primary"
                        class="ml-2 info-icon"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-information
                      </v-icon>
                    </template>
                    <span>System will show all default coffee data values in app side</span>
                  </v-tooltip>
                </template>
              </v-radio>
              <v-radio
                :value="true"
                label="Hide Default Data"
                class="lot-id-radio"
              >
                <template v-slot:label>
                  <span class="lot-id-label">Hide Default Data</span>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        color="primary"
                        class="ml-2 info-icon"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-information
                      </v-icon>
                    </template>
                    <span>System will hide all default coffee data values in app side</span>
                  </v-tooltip>
                </template>
              </v-radio>
            </v-radio-group>
            </div>

        </div>
        <hr>
        <div class="lot-id-section mt-4">
            <h4 class="lot-id-section-title mb-4"> Farmer’s Farm Data Sharing Consent </h4>
            <label> Define whether farmers are required to provide a digital signature for data sharing consent during the registration process. </label>
            <v-radio-group v-model="farmerConsent.isEnabled" class="lot-id-radio-group mt-4">
              <v-radio
                value="enabled"
                label="enabled"
                class="lot-id-radio"
              >
                <template v-slot:label>
                 Enabled
                </template>
              </v-radio>
               <label class="margin-left-30"> Farmers must sign the authorization before submitting their registration. Please upload the contract they will be consenting to.  </label>
              <div>
                <v-card class="custom-card py-10" rounded="0" flat>
                                
              <h3 class="py-4">{{ "Attach File" }}</h3>
              <div
                class="border-outline"
                @drop.prevent="onDrop($event)"
                @dragover.prevent="dragover = true"
                @dragenter.prevent="dragover = true"
                @dragleave.prevent="dragover = false"
                :class="{ 'grey lighten-2': dragover }"
              >
                <!-- New Addition -->
                <v-row
                  class="d-flex flex-column"
                  dense
                  align="center"
                  justify="center"
                >
                  <v-icon
                    color="primary"
                    :class="[dragover ? 'mt-2, mb-6' : 'mt-5']"
                    size="85"
                    >mdi-cloud-upload</v-icon
                  >
                  <p class="font-weight-bold">
                    {{ $t("activationKey.dragDrop") }}
                    <input
                      type="file"
                      @change="fileData($event)"
                      accept="application/pdf"
                      capture
                      ref="file"
                      style="display:none"
                    /><b class="browse" @click="$refs.file.click()">
                      {{ $t("activationKey.browse") }}
                    </b>
                    {{ $t("activationKey.yourFile") }}.
                  </p>
                </v-row>
              </div>
              <p class=" px-3 mt-2">
                <strong>{{ $t('activationKey.note') }}:</strong> {{ $t('activationKey.pdfSupport') }}
              </p>
              <p v-if="fileRequired" style="color:#ff0000"> {{ $t('errors.required') }} </p>

                <!-- Progress bar section -->
              <v-row v-if="isUploading" align="center" justify="center">
                <v-col cols="12" class="text-center">
                  <p>{{ $t('activationKey.pleaseWait') }}</p>
                  <v-progress-linear :value="uploadPercentage" height="7" color="primary" />
                  <p>{{ uploadPercentage }}%</p>
                </v-col>
              </v-row>

              <v-row
                v-for="(file, index) in uploadedFileUrls" :key="index"
              >
                <v-col cols="6">
                  <div>
                    <v-sheet
                      style="border: 1px solid #ccc; border-radius: 0px; background-color: #fafafa; position: relative;"
                      class="d-flex align-center justify-center flex-wrap text-center px-4 mr-2"
                      height="100"
                      width="100"
                      :title="urlToFileName(file.file_path)"
                    >
                      <div v-if="file.id">
                        <v-icon style=" position: absolute; top:0; right:0;" @click="removeFile(file.id)">
                        mdi-trash-can-outline
                        </v-icon>
                      </div>
                      <v-icon
                        dark
                        style="color: green"
                        @click="openFile(file.file_path)"
                      >
                        mdi-eye
                      </v-icon>
                      
                      <div class="wrapped-text">{{ urlToFileName(file.file_path) }}</div>
                    </v-sheet>
                  </div>
                </v-col>
              </v-row>
              <v-divider class="my-5"></v-divider>
              <div class="err" v-if="extenshionError">
                {{ $t("activationKey.incorectFileType") }}.
              </div>
              <div class="err" v-if="errorUploading">
                {{
                  $t(
                    !isInvalidData
                      ? "activationKey.somethingWentWrong"
                      : "activationKey.invalidFileData"
                  )
                }}
              </div>
              <div class="successMsg" v-if="successUploaded">
                {{ $t("activationKey.fileUploadedSuccess") }}
              </div>
              <div class="numRecords" v-if="uploadId">
                {{ numRecords }} {{ $t("activationKey.countRecords") }}
              </div>
            </v-card>
              </div>

              <v-radio
                value="disabled"
                label="disabled"
                class="lot-id-radio"
              >
                <template v-slot:label>
                  Disabled
                </template>
              </v-radio>
              <label class="margin-left-30"> Define whether farmers are required to provide a digital signature for data sharing consent during the registration process. </label>
            </v-radio-group>
          </div>

          <hr>

          <div class="mt-4">
             <h4 class="lot-id-section-title mb-4"> Farmer Digital ID Card </h4>
            <label> Enable digital ID card generation for farmers. This allows admins, technicians, and farmers to download or print official identification within the ecosystem. </label>

            <v-radio-group v-model="farmerConsent.digitalIdCardEnabled" class="lot-id-radio-group mt-4">
              <v-radio
                value="enabled"
                label="enabled"
                class="lot-id-radio"
              >
                <template v-slot:label>
                 Enabled
                </template>
              </v-radio>
              <label class="margin-left-30"> If enabled, QR-coded digital IDs will be automatically generated for all registered farmers. </label>

              <v-radio
                value="disabled"
                label="disabled"
                class="lot-id-radio"
              >
                <template v-slot:label>
                  Disabled
                </template>
              </v-radio>
              <label class="margin-left-30"> ID card generation will be hidden across the platform. </label>
              </v-radio-group>

          </div>
          
        

        <!-- Save and Cancel Buttons -->
        <div class="d-flex justify-end mt-6">
          <v-btn
            class="text-none mr-3"
            height="40"
            color="primary"
            outlined
            @click="handleBack"
          >
            <span>{{ $t('cancel') }}</span>
          </v-btn>
          <v-btn
            class="primary text-none"
            height="40"
            @click="handleSave"
            :loading="saving"
          >
            <span>{{ $t('save') }}</span>
          </v-btn>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import CoffeeService from '@/_services/CoffeeService';
import loadingMixin from "@/mixins/LoadingMixin";
import s3UploadService from "@/_services/S3UploadService";
import PermissionsService from "@/_services/PermissionsService";


export default {
  name: 'GeneralSettings',
  mixins: [loadingMixin],
  data() {
    return {
      saving: false,
      coffeeProcessorSettings: {
        greenBeansLotIdType: 'system',
        qualityGradingLotIdType: 'system',
        defaultCoffeeDataSetting: 'show',
      },
      farmerConsent:{
          isEnabled:"disabled",
          consentPdf:null,
          digitalIdCardEnabled:"disabled"
      },
      dragover: false,
      fileRequired: false,
      isUploading: false,
      uploadPercentage: 0,
      uploadedFileUrls: [], // [{ id, file_path }]
      newUploadedFileUrls:[],
      comment: [],
      extenshionError: false,
      errorUploading: false,
      isInvalidData: false,
      successUploaded: false,
      uploadId: null,
      numRecords: 0,
      uploadedFiles:[],
    };
  },
  async mounted() {
    this.startLoading();
    try {
      await this.fetchCoffeeProcessorSettings();
      await this.getFarmerConsentSettings()
    } catch (error) {
      console.error('Error loading settings:', error);
      this.$notify({
        title: 'Failed to load settings',
        type: 'error',
      });
    } finally {
      this.stopLoading();
    }
  },
  methods: {
    handleBack() {
      this.$router.go(-1);
    },

    async getFarmerConsentSettings() {
      try {
        const response = await PermissionsService.getAppSettings();
        if (response.data?.profileAuthenticationSettings) {
          this.farmerConsent.isEnabled = response.data.profileAuthenticationSettings.enable_data_sharing_consent ? "enabled" : "disabled";
          this.farmerConsent.digitalIdCardEnabled = response.data.profileAuthenticationSettings.enable_farmer_id ? "enabled" : "disabled";
          this.farmerConsent.consentPdf = response.data.profileAuthenticationSettings.consent_pdf || null;
          if(this.farmerConsent.consentPdf) {
            this.uploadedFileUrls = [{file_path: this.farmerConsent.consentPdf}];
          }
        }
      } catch (error) {
        console.error('Error fetching farmer consent settings:', error);
        // Set defaults if fetch fails
        this.farmerConsent.isEnabled = "enabled";
        this.farmerConsent.digitalIdCardEnabled = "enabled";
        this.farmerConsent.consentPdf = null;
      }
    },

    saveConsentSettingsWithPDF() {
      return PermissionsService.updateAppConsentSettings({
        enable_data_sharing_consent: this.farmerConsent.isEnabled === "enabled",
        enable_farmer_id: this.farmerConsent.digitalIdCardEnabled === "enabled",
        consent_pdf: this.uploadedFileUrls.length > 0 ? this.uploadedFileUrls[0].file_path : null,
      });
    },

    saveConsentSettingsWithooutPDF() {
      return PermissionsService.updateAppConsentSettings({
        enable_data_sharing_consent: this.farmerConsent.isEnabled === "enabled",
        enable_farmer_id: this.farmerConsent.digitalIdCardEnabled === "enabled",
      });
    },
    
    async fetchCoffeeProcessorSettings() {
      try {
        const response = await CoffeeService.getCoffeeProcessorSettings();
        if (response.success && response.data) {
          this.coffeeProcessorSettings = {
            greenBeansLotIdType: response.data.greenBeansLotIdType || 'system',
            qualityGradingLotIdType: response.data.qualityGradingLotIdType || 'system',
            defaultCoffeeDataSetting: response.data.defaultCoffeeDataSetting || true,
          };
        }
      } catch (error) {
        console.error('Error fetching coffee processor settings:', error);
        // Set defaults if fetch fails
        this.coffeeProcessorSettings = {
          greenBeansLotIdType: 'system',
          qualityGradingLotIdType: 'system',
          defaultCoffeeDataSetting: true,
        };
      }
    },
    async handleSave() {
      this.saving = true;
      try {
        const response = await CoffeeService.updateCoffeeProcessorSettings({
          greenBeansLotIdType: this.coffeeProcessorSettings.greenBeansLotIdType,
          qualityGradingLotIdType: this.coffeeProcessorSettings.qualityGradingLotIdType,
          defaultCoffeeDataSetting: this.coffeeProcessorSettings.defaultCoffeeDataSetting,
        });

        await this.saveConsentSettingsWithooutPDF()
        
        if (response.success) {
          this.$notify({
            title: 'Settings saved successfully',
            type: 'success',
          });
        } else {
          throw new Error('Failed to save settings');
        }
      } catch (error) {
        console.error('Error saving settings:', error);
        this.$notify({
          title: 'Failed to save settings',
          text: error.message || 'An error occurred while saving settings',
          type: 'error',
        });
      } finally {
        this.saving = false;
      }
    },
    onDrop(e) {
          this.isInvalidData = false;
          this.dragover = false;
          this.errorUploading = false;
          this.successUploaded = false;
          if (this.uploadedFiles.length > 0) this.uploadedFiles = [];
          const files = e.dataTransfer.files;
          if (files.length === 0) return;
          const validFiles = [];
          for (let i = 0; i < files.length; i++) {
            if (files[i].type !== "application/pdf") {
              this.extenshionError = true;
              return;
            }
            validFiles.push(files[i]);
          }
          if (validFiles.length > 0) {
            this.uploadedFiles = validFiles;
    
            this.fileUploaded = true;
            this.extenshionError = false;
            this.fileDropped = true;
            this.validateFiles();
          }
        },
        fileData(e) {
          this.isInvalidData = false;
          this.errorUploading = false;
          this.successUploaded = false;
          if (this.uploadedFiles?.length > 0) this.uploadedFiles = [];
          const files = e.target.files;
          if (files.length === 0) return;
    
          if (files[0].type !== "application/pdf") {
            this.extenshionError = true;
            this.uploadedFiles = [];
            return;
          }
    
          for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (file.type !== "application/pdf") {
              this.extenshionError = true;
              this.uploadedFiles = [];
              return;
            }
            this.uploadedFiles.push(file);
          }
          console.log("Files selected:-----------", this.uploadedFiles);
          this.fileRequired =  false
          this.fileUploaded = true;
          this.extenshionError = false;
          this.fileDropped = true;
          this.validateFiles();
        },
        validateFiles() {
          this.extenshionError = false;
          this.uploadedFiles.forEach((file) => {
            if (file.type !== "application/pdf") {
              this.extenshionError = true;
            }
          });
          if (this.extenshionError) {
            this.uploadedFiles = [];
            return;
          }
          this.fileDropped = true;
          this.submitPdf();
        },


        async removeFile(fileId) {
          console.log("Removing file with ID:", fileId);
          // const confirmed = window.confirm("Are you sure you want to delete this file?");
          // if (!confirmed) return;
          // try {
          //   this.startLoading()
          //   await deforestationService.removeRiskMitigationFile({
          //     productionPlaceId: this.productionPlaceId,
          //      fileId: parseInt(fileId),
          //   });
          //   console.log("File removed successfully from database");
          //   this.stopLoading();
          //   this.closeModal(true);
          // } catch (error) {
          //   console.error("Error removing file from database:", error);
          //   this.stopLoading();
          // }
        },

        async openFile(url) {
          try {
              // Extract the file key from the URL (after bucket URL)
              const fileKey = url.split('.com/')[1];
              // Get the URL for viewing the file
              const viewUrl = await s3UploadService.getFileUrl(fileKey);
              window.open(viewUrl, "_blank");
          } catch (error) {
              console.error('Error opening file:', error);
          }
       },

      urlToFileName(url) {
        return url.split("/").at(-1);
      },

      async submitPdf() {
            if (this.extenshionError || this.uploadedFiles.length == 0) {
              this.fileRequired = true 
              return
            }
            // initial state for uploadingps3UploadService
            this.isUploading = true;
            this.uploadPercentage = 0;
            try {
              const folder = "farmer-consent-pdfs";
              console.log("Starting upload for files:", this.uploadedFiles);
              const uploadPromises = this.uploadedFiles.map((file) => {
                return s3UploadService.singleUpload(file, folder, (progress) => {
                    this.uploadPercentage = progress;
                  }).then((result) => {
                    console.log("File uploaded successfully:", result);
                    this.newUploadedFileUrls.push({file_path: result.fullPath});
                    return result;
                });
              });
              const results = await Promise.all(uploadPromises);
              this.uploadedFileUrls = [...this.newUploadedFileUrls];
              this.successUploaded = true;
              this.uploadedFiles = [];
              this.isUploading = false;
              await this.saveConsentSettingsWithPDF()
              console.log("Files uploaded successfully:", results);
            } catch (err) {
              this.errorUploading = true;
              this.isUploading = false;
              console.error("Error uploading files:", err);
            }
          },

  },
};
</script>

<style scoped lang="scss">
.margin-left-30 {
  margin-left: 31px;
}
.general-settings {
  .settings-card {
    background-color: #ffffff;
    border-radius: 4px;
    padding: 24px;
  }

  .settings-content {
    max-width: 100%;
  }

  .section-title {
    font-size: 18px;
    font-weight: 600;
    color: #1e1e1e;
  }

  .section-subtitle {
    font-size: 14px;
    font-weight: 500;
    color: #787878;
  }

  .green-button {
    background-color: #00BD73 !important;
    color: white !important;
    border: none !important;
    
    &:hover {
      background-color: #00a65a !important;
    }
  }

  ::v-deep .v-select {
    .v-input__control {
      min-height: 40px;
    }
  }

  ::v-deep .v-text-field {
    .v-input__control {
      min-height: 40px;
    }
  }

  .lot-id-section {
    margin-bottom: 32px;
  }

  .lot-id-section-title {
    font-size: 16px;
    font-weight: 600;
    color: #1e1e1e;
  }

  .lot-id-radio-group {
    margin-top: 0;
  }

  .lot-id-radio {
    margin-bottom: 12px;
  }

  .lot-id-label {
    font-size: 14px;
    color: #1e1e1e;
  }

  .info-icon {
    cursor: help;
    vertical-align: middle;
  }

  ::v-deep .v-radio {
    .v-input--selection-controls__input {
      margin-right: 12px;
    }
  }
}

::v-deep .bg .v-input__slot {
  background-color: $primary-color;
  color: #ffffff;
}

.border-outline {
  background-color: #ffffff !important;
  border: 5px dotted #aaaaaa !important;
  height: 200px;
}

.border-outline-success {
  background-color: #ffffff !important;
  border: 5px dotted #aaaaaa !important;
}

.green-txt {
  color: #00bd73;
  margin-bottom: 34px;
  font-size: 20px;
}
.browse {
  cursor: pointer;
  color: blue;
}
.err {
  color: red;
  padding-left: 40px;
}
.successMsg {
  color: #00bd73;
  padding-left: 40px;
}
.numRecords {
  padding-left: 40px;
  font-size: 12px;
}
.wrapped-text {
  width: 80px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
